import React from 'react'
import * as styles from './index.module.css'
import { GatsbyImage } from "gatsby-plugin-image";
import { GradientBorder } from '../commons'
import Button from '../Button/'
import ArrowDown from '../../../assets/images/ArrowDown.svg'
import Link from '../Link'

const Os0Pricing = ({ title, subtitle, components, ctaText, ctaUrl }) => {
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <div className={styles.title}>{title}</div>
        <div className={styles.pricingBox}>
          {subtitle.subtitle.split('\n').map((price, idx) => (
            <div className={styles.price} key={idx}>
              <div className={styles.priceTitle}>{price.split(':')[0]}</div>
              <div className={styles.value}>{price.split(':')[1]}</div>
            </div>
          ))}
        </div>
        {components && components.length > 0 && (
          <div className={styles.promoText}>{components[0].title}</div>
        )}
        <div className={styles.buttonContainer}>
          <Link to={ctaUrl}>
            {typeof window !== `undefined` && window.innerWidth <= 450 && (
              <Button className={styles.tts} style={{ width: '285px' }}>
                {ctaText}
              </Button>
            )}

            {typeof window !== `undefined` && window.innerWidth > 450 && (
              <Button className={styles.tts} style={{ width: '415px' }}>
                {ctaText}
              </Button>
            )}
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Os0Pricing
